var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list',{staticClass:"pl-list",attrs:{"three-line":""}},_vm._l((_vm.currentSubcategories),function(subcategory){return _c('subcategory-list-item',{key:subcategory['.key'],attrs:{"subcategory":subcategory}})}))}
var staticRenderFns = []

export { render, staticRenderFns }